import i18next from '../i18next';
import { isZh } from '@meego/utils/src/language/env/base';
// import logoCn from '../asset/svg/logo_Cn.ts';
// import logoEn from '../asset/svg/logo_En.ts';
import { TEA_APP_ID } from './tea';

export const defaultTenantConfig = /*#__PURE__*/ (() => ({
  get brand_name() {
    return i18next.t('Meego_Shared_Web_Common_Meego');
  },
  get feishu_brand_name() {
    return i18next.t('Meego_Shared_Web_Common_Feishu');
  },
  get workbench_title() {
    return i18next.t('Meego_Shared_Web_Common_Workbench');
  },
  get brand_desc() {
    return i18next.t('Meego_Shared_Web_Common_MakeProjectManagementEasier');
  },
  get web_title() {
    return i18next.t('Meego_Shared_Web_Common_MeegoProjectManagementPlatform');
  },
  get logo_url_promise() {
    return isZh ? import('../asset/svg/logo_Cn.ts') : import('../asset/svg/logo_En.ts');
  },
  get bot_name() {
    return i18next.t('Meego_Shared_Intranet_Common_BotName');
  },
}))();

export const getBucketRegionByRegion = (region: string) => {
  if (region === 'va') {
    return 'us';
  }
  if (region === 'sg') {
    return 'sg';
  }
  return 'jp';
};

export const defaultConfig = /*#__PURE__*/ (() => ({
  larkAppLink:
    'https://applink.feishu.cn/client/chat/chatter/add_by_link?link_token=d96i6e7b-4bd6-48fd-9fe7-05f4813e2f88',
  calculationFieldHelpDoc: 'https://bytedance.feishu.cn/docs/doccnKWQfgw3PjAriYf1jFYx31e',
  externalHiddenFields: [],
  externalHiddenControls: [],
  larkPassportAppId: 104,
  larkPassportTemplateId: '7389845492933017603',
  larkPassportAppName: 'meego',
  larkPassportPattern: 4,
  TeaConfig: {
    channel_domain: window.location.origin,
    report_url: '/goapi/v1/event/record',
    disable_webid: true,
    channel: 'cn',
    app_id: TEA_APP_ID.CN,
  },
  slardarConfig: {},
  helpcenterUrl: 'https://meego.feishu.cn/helpcenter/home',
  passportApi: 'passport.feishu.cn',
  applinkApi: undefined,
}))();
